import { Card, CardItem, Skeleton } from "@walmart-web/livingdesign-components"
import { concatClassNames } from "helpers/jsxHelpers"
import React from "react"
import "./index.scss"

interface SummaryCardSkeletonProps {
	cardsAmount: number
	className?: string
	alignment?: SkeletonCardsAlignmentType
}

type SkeletonCardsAlignmentType = "left" | "spaced-evenly"

const SummaryCardSkeleton: React.FC<SummaryCardSkeletonProps> = (props) => {
	const { cardsAmount, className, alignment = "left" } = props
	return (
		<div
			data-testid={"card-skeleton-container"}
			className={concatClassNames(["container", `list-card-${alignment}`])}
		>
			{Array.from(Array(cardsAmount).keys()).map((value) => (
				<Card
					key={value}
					role="skeletonview"
					className={concatClassNames(["skeleton-container", className])}
				>
					<CardItem className="card-container">
						<Skeleton height={30} className="card-header" variant="rectangle" />

						<div className="card-percentage">
							<Skeleton
								height={25}
								className="card-description"
								variant="rectangle"
							/>
						</div>
					</CardItem>
				</Card>
			))}
		</div>
	)
}

export default SummaryCardSkeleton
